import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, } from '@mui/material';
import { Close } from '@icons/index';
import { Colors } from '@constants/colors.constants';

export interface PopupProps {
	handleClose?: () => void;
	title: string;
	description: string;
	buttons?: {
		label: string;
		color: 'primary' | 'error';
		onClick: () => void;
		disabled?: boolean;
	}[];
	handleSubmit?: () => void;
	maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg';
}

const Popup: FC<PopupProps> = (props) => {
	const { title, description, handleClose, maxWidth = 'sm', handleSubmit, buttons = [] } = props;
	return (
		<Dialog open={true} onClose={handleClose} fullWidth maxWidth={maxWidth}>
			{!!handleClose && (
				<IconButton
					sx={{ position: 'absolute', right: 10 }}
					onClick={handleClose}
					style={{ position: 'absolute' }}
				>
					<Close />
				</IconButton>
			)}
			<DialogTitle
				sx={{
					display: 'flex',
					justifyContent: 'center',
					marginBottom: 0 + '!important',
					marginTop: '25px !important',
					backgroundColor: Colors.background,
				}}>{title}</DialogTitle>
			<DialogContent sx={{
				textAlign: 'center',
				padding: '0 24px 24px 24px !important',
				marginBottom: 0 + '!important',
			}}>{description}</DialogContent>
			<DialogActions>
					{buttons.map((button) => (
						<Button
							key={`${button.label} - ${button.color}`}
							color={button.color}
							variant="contained"
							onClick={() => {
								button.onClick();
								handleSubmit?.();
							}}
							disabled={button.disabled}
						>
							{button.label}
						</Button>
					))}
			</DialogActions>
		</Dialog>
	);
};

export default Popup;
